module.exports = __webpack_public_path__ + "img/35.7.Chla.c57e4023.png";